import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Back from "../components/button/back";

const EkskulAll = () => {
  const [ekskuls, setEkskuls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchEkskuls = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/ekskul`);
        setEkskuls(response.data);
        setLoading(false);
      } catch (error) {
        setError("Gagal mengambil data ekskul.");
        setLoading(false);
      }
    };

    fetchEkskuls();
  }, []);

  const getMediaUrl = (filename) => `${BASE_URL}api/ekskul/media/${filename}`;

  if (loading) return <div className="text-center mt-10">Memuat...</div>;
  if (error) return <div className="text-center text-red-600">{error}</div>;

  return (
    <div className="mx-10 rounded-xl drop-shadow-lg my-10 bg-white">
      <div className="flex justify-center py-10">
        <h1 className="text-3xl font-bold mb-5">Ekstrakurikuler</h1>
      </div>

      {ekskuls.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 pb-10">
          {ekskuls.map((ekskul) => (
            <div
              key={ekskul._id}
              className="transform transition duration-300 hover:scale-105 rounded-lg shadow-md w-72 mx-auto hover:shadow-xl bg-blue-400/30"
            >
              <div className="m-2 h-36 rounded-lg overflow-hidden bg-gradient-to-br from-rose-100 via-purple-200 to-purple-200 flex items-center justify-center">
                {ekskul.Gambar?.filename ? (
                  ekskul.Gambar.mimetype?.startsWith("image/") ? (
                    <img
                      src={getMediaUrl(ekskul.Gambar.filename)}
                      alt={ekskul.Judul}
                      className="w-full h-full object-cover"
                    />
                  ) : ekskul.Gambar.mimetype?.startsWith("video/") ? (
                    <video
                      src={getMediaUrl(ekskul.Gambar.filename)}
                      className="w-full h-full object-cover"
                      muted
                      loop
                      autoPlay
                    />
                  ) : (
                    <span className="text-gray-500">Tidak ada media</span>
                  )
                ) : (
                  <span className="text-gray-400 italic">Media kosong</span>
                )}
              </div>
              <div className="px-5 pt-3 pb-5 flex flex-col">
                <h2 className="font-semibold text-lg mb-2">{ekskul.Judul}</h2>

                <button
                  className="bg-blue-500 text-white px-3 py-1 rounded-md transition duration-150 hover:bg-blue-700"
                  onClick={() => navigate(`/ekskul-satu/${ekskul._id}`)}
                >
                  Baca
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-600 pb-10">
          Tidak ada ekskul ditemukan.
        </div>
      )}

      <div className="flex justify-center pb-10">
        <Link to="/">
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default EkskulAll;
